import Vue from 'vue';
import Router from 'vue-router';
import {i18n} from '@/plugin/i18n';
import {CONF} from './constants/conf';
import {Locales} from '@/plugin/Locales';


function load(component: string) {
    return () => import(/* webpackChunkName: "[request]" */ `@/components/${component}.vue`);
}


Vue.use(Router);


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:lang',
            component: {
                template: '<router-view></router-view>',
            },
            beforeEnter(to, from, next) {
                // la local est de type : lang-MARKET
                // c'est le premier segment de l'url
                const localeDatas = to.params.lang.split('-');
                const lang = localeDatas[0];
                Locales.market = localeDatas[1];
                if (i18n.locale === lang) {
                    return next();
                }

                import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}.ts`).then((msg) => {
                    i18n.setLocaleMessage(lang, msg[lang]);
                    i18n.locale = lang;
                    return next();
                });

            },
            children: [
                {
                    path: 'index.html',
                    alias: '',
                    name: 'home',
                    component: load('PageSelector'),
                    meta: { hideLogo: true },
                    props: (route) => {
                        // @ts-ignore
                        gtag('config', process.env.VUE_APP_GTMID, {
                            'page_title' : 'Home',
                            'page_path': document.location.href,
                        });
                        return {
                            pageName: 'Home',
                        };
                    },
                },
                {
                    path: ':page/index.html',
                    name: 'page',
                    component: load('PageSelector'),
                    props: (route) => {
                        const page = route.params.page;
                        // on recupère la bon item du menu en fonction du segement
                        // on pourra ainsi passer le nom de la pageName (correspondant à la /pages/[pageName].vue) au page selector
                        const menuItem = Locales.mainMenu.filter((item) => (
                            item.segment === page
                        ));

                        // si on trouve pas de correspondance, on renvoie sur la home
                        if(menuItem.length === 0){
                            return {
                                pageName: 'Home',
                            }
                        }
                        // @ts-ignore
                        gtag('config', process.env.VUE_APP_GTMID, {
                            'page_title' : menuItem[0].title,
                            'page_path': document.location.href,
                        });

                        return {
                            pageName: menuItem[0].pageComponent,
                        };
                    },
                },
            ],
        },
        {
            path: '*',
            meta: { hideLogo: true },
            redirect: () => (CONF.HOME_PAGE),
        },
      ],
});
